import { Pipe, PipeTransform } from '@angular/core';
import { FavoriteProvider } from '../../providers/favorite/favorite';
import { Customer } from '../../models';
@Pipe({
  name: 'favorites'
})
export class FavoritesPipe implements PipeTransform {
  constructor(private favorite: FavoriteProvider) {

  }

  /**
   *
   */
  transform(customers: Array<Customer>, favorites: Array<number>): Array<Customer> {
    if (favorites) {
      this.favorite.getFavorites().then(favoritesStorage => {
        if (favoritesStorage) {
          return [customers[0]];
        } else {
          return customers;
        }
      });
    } else {
      return customers;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/favorites/favorites.ts